var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25684 2.29642C7.73358 2.10576 8.26642 2.10576 8.74316 2.29642L12.1553 3.66165C12.6653 3.86584 12.9998 4.36032 13 4.9097V6.39017C12.9999 9.24987 11.499 11.9002 9.04688 13.3716C8.40248 13.7581 7.59752 13.7581 6.95312 13.3716C4.50098 11.9002 3.00007 9.24987 3 6.39017V4.9097C3.00024 4.36032 3.33469 3.86584 3.84473 3.66165L7.25684 2.29642ZM10.0928 6.55716C9.84857 6.33367 9.46895 6.35036 9.24512 6.59427L7.58887 8.39993L6.71973 7.5972C6.47632 7.37275 6.09679 7.38824 5.87207 7.63138C5.6474 7.87477 5.66207 8.25424 5.90527 8.47903L7.21777 9.68997C7.33497 9.79815 7.49104 9.8558 7.65039 9.84915C7.8096 9.8424 7.9597 9.77229 8.06738 9.65482L10.1299 7.40482C10.3534 7.16053 10.3369 6.78096 10.0928 6.55716Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceVerified);
export default __webpack_public_path__ + "static/media/Insurance_verified.a49f3ebcd1a29f25442e5c510b1b5995.svg";
export { ForwardRef as ReactComponent };